import { SearchResultDataType } from 'components/SearchInput/interfaces';
import { REGEX_NON_DIGITS } from 'constants/regex';
import { IPropertyCompany } from 'interfaces/IPropertyCompany';
import { IProperty } from 'interfaces/IProperty';

export const parseMapboxIntoProperty = (
  mapbox: Partial<IPropertyCompany>,
): IProperty => {
  return {
    propertyId: mapbox.propertyId,
    name: mapbox?.displayAddress?.split(',')[0],
    primaryAddress: mapbox.displayAddress,
    longitude: mapbox.mapBoxDetail?.longitude,
    latitude: mapbox.mapBoxDetail?.latitude,
  };
};

export const parseMapboxIntoPropertyCompany = (
  data: SearchResultDataType[],
) => {
  return data?.map(mapbox => {
    const idNumbersOnly = String(mapbox.id).replace(REGEX_NON_DIGITS, '');

    return {
      businessParkName: undefined,
      companyId: undefined,
      displayAddress: mapbox?.displayAddress,
      headquarters: undefined,
      id: mapbox.id,
      industryName: undefined,
      marketId: undefined,
      marketName: undefined,
      mergedAt: undefined,
      mergedCompanyId: undefined,
      mergedCompanyName: undefined,
      micromarketName: undefined,
      name: mapbox?.displayAddress,
      numberOfBuildings: undefined,
      propertyClassName: undefined,
      propertyId: Number(idNumbersOnly),
      propertyName: undefined,
      propertyStatusName: undefined,
      propertyType: undefined,
      propertyTypeId: undefined,
      state: undefined,
      submarketId: undefined,
      submarketName: undefined,
      type: mapbox.type,
      mapBoxDetail: {
        longitude: mapbox.mapBoxDetail?.longitude,
        latitude: mapbox.mapBoxDetail?.latitude,
      },
    };
  });
};
